// Next.js runs this file before any page code (client instrumentation hook),
// so the error reporter listens even when a page crashes while its modules
// load. Started from Providers' effect it could not: on 2026-10-01 an import
// cycle in the cash-out mutation crashed /zero/coupons before React mounted,
// and the crash never reached /admin/monitor.
import { initErrorReporter } from "@/lib/errorReporter";

initErrorReporter();
